import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const ProductsLayout: FC<{}> = () => {
  return (
    <Box sx={{ bgcolor: "#1b1b1b", color: "#fff" }}>
      <Outlet />
    </Box>
  );
};

export default ProductsLayout;
